import { render, staticRenderFns } from "./club-summary-burns.vue?vue&type=template&id=14e5fa67&"
import script from "./club-summary-burns.vue?vue&type=script&lang=js&"
export * from "./club-summary-burns.vue?vue&type=script&lang=js&"
import style0 from "./club-summary-burns.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14e5fa67')) {
      api.createRecord('14e5fa67', component.options)
    } else {
      api.reload('14e5fa67', component.options)
    }
    module.hot.accept("./club-summary-burns.vue?vue&type=template&id=14e5fa67&", function () {
      api.rerender('14e5fa67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/account/club-summary-burns.vue"
export default component.exports